import {
  TransactionDetailModel,
  TransactionManagerReviewStatus,
} from 'src/models/transaction.models'

interface ReceiptAgentManagerReviewVisibility {
  receiptAgentFlyoutEnabled: boolean
  managerReviewRulesEnabled: boolean
}

export const shouldRenderReceiptAgentManagerReview = ({
  receiptAgentFlyoutEnabled,
  managerReviewRulesEnabled,
}: ReceiptAgentManagerReviewVisibility): boolean =>
  receiptAgentFlyoutEnabled && managerReviewRulesEnabled

export const hasDisplayableManagerReview = (
  transaction: Pick<
    TransactionDetailModel,
    'managerId' | 'managerReviewId' | 'managerReviewStatus'
  >,
): boolean =>
  Boolean(transaction.managerReviewId || transaction.managerId) ||
  transaction.managerReviewStatus ===
    TransactionManagerReviewStatus.AutoReviewed
